import VibratingButton from "@/components/base/button/VibratingButton.tsx";
import IconCheck from "@/assets/icons/check.svg?react"
import {Option} from "@/pages/get-don/tasks.types.ts";

interface Props {
options: Option[];
value: string[];
onChange: (ids: string[]) => void;
}

const MultipleChoose = ({ options, value, onChange }: Props) => {
  const toggleSelect = (id: string) => {
    if(value.includes(id)) {
      onChange(value.filter((item)=> item !== id))
    }else{
      onChange([...value, id]);
    }
  };
  return (
    <div className="flex flex-col items-center w-full gap-2">
      {options?.map((item) => {
        const isSelected = value.includes(item.id);

        return (
          <VibratingButton
            key={item.id}
            vibrationType="selection"
            className={`p-px rounded-xl w-full cursor-pointer transition-300 ${
              isSelected
                ? "bg-yellow-linear shadow-[0_7px_33px_-24px_rgba(235,161,50,0.24)]"
                : "bg-transparent"
            }`}
            onClick={() => toggleSelect(item.id)}
          >
            <div className='bg-gray-4 rounded-xl'>
            <div
              className={`p-2.5 px-3 w-full rounded-xl transition-300 ${
                isSelected
                  ? "bg-[linear-gradient(83deg,rgba(251,199,108,0.08)_-31px,rgba(235,161,50,0.08)_100px)]"
                  : "bg-gray-4"
              }`}
            >
              <div className="flex items-start justify-between w-full gap-3">
                <p className="text-sm font-semibold text-white text-start leading-5">
                  {item.title}
                </p>

                <div
                  className={`w-5 h-5 rounded-sm border border-white/08 flex items-center justify-center transition-200 ${
                    isSelected
                      ? "bg-yellow-linear border-yellow-linear"
                      : ""
                  }`}
                >
                  {isSelected && (
                    <IconCheck className="w-3.5 h-3.5 text-gray-4" />
                  )}
                </div>
              </div>
            </div>
            </div>
          </VibratingButton>
        );
      })}
    </div>
  );
};

export default MultipleChoose;
